
enum RenderMask {
  OPAQUE        = 1<<0,
  BLENDED       = 1<<1,
}

export default RenderMask;